export default "__VITE_ASSET__DdoYCZtC__"